import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { PagesComponent } from "./pages.component";
import { MainComponent } from "./main/main.component";

const routes: Routes = [
  {
    path: "",
    component: PagesComponent,
    children: [
      { path: "home", component: MainComponent },
      {
        path: "management-liquidation",
        loadChildren:
          () => import('./management-liquidation/management-liquidation.module').then(m => m.ManagementLiquidationModule),
      },
      {
        path: "gestion-pm",
        loadChildren: () => import('./gestion-pm/gestion-pm.module').then(m => m.GestionPmModule),
      },
      {
        path: "precautionary",
        loadChildren:
          () => import('./precautionary/precautionary.module').then(m => m.PrecautionaryModule),
      },
      {
        path: "paperwork",
        loadChildren: () => import('./paperwork/paperwork.module').then(m => m.PaperworkModule),
      },
      {
        path: "expediente",
        loadChildren: () => import('./expedientes/expedientes.module').then(m => m.ExpedientesModule),
      },
      {
        path: "infoExperto",
        loadChildren: () => import('./info-experto/info-experto.module').then(m => m.InfoExpertoModule),
      },
      {
        path: "notificacion/notificacion",
        loadChildren: () => import('./notification/notification.module').then(m => m.NotificationModule),
      },
      {
        path: "notificacion/notificacion-cidi",
        loadChildren:
          () => import('./notification-cidi/notification.module').then(m => m.NotificationModule),
      },
      {
        path: "documentacion",
        loadChildren:
          () => import('./documentation/documentation.module').then(m => m.DocumentationModule),
      },
      {
        path: "calendar",
        loadChildren: () => import('./calendar/calendar.module').then(m => m.CalendarModule),
      },
      {
        path: "reporte",
        loadChildren: () => import('./reporte/reporte.module').then(m => m.ReporteModule),
      },
      {
        path: "gestion-pm/user-management",
        loadChildren:
          () => import('./user-management/user-management.module').then(m => m.UserManagementModule),
      },
      {
        path: "transfers",
        loadChildren:
          () => import('./transf-dgr-interface/transf-dgr-interface.module').then(m => m.TransfDgrInterfaceModule),
      },
      {
        path: "executive-title",
        loadChildren:
          () => import('./executive-titles/executive-titles.module').then(m => m.ExecutiveTitlesModule),
      },
      { path: "fees", loadChildren: () => import('./fees/fees.module').then(m => m.FeesModule) },
      {
        path: "bank-response",
        loadChildren: () => import('./bank-response/bank-response.module').then(m => m.BankResponseModule),
      },
      // {
      //   path: "asignation",
      //   loadChildren: () => import('./assignment/assignment.module').then(m => m.AssignmentModule),
      // }, comentado en base a que el módulo de asignación se quitó del menú en la vista
      {
        path: "management-liquidation/ant/assignment-reassignment",
        loadChildren:
          () => import('./manual-assignment/manual-assignment.module').then(m => m.ManualAsignmentModule),
      },
      { path: "", redirectTo: "home", pathMatch: "full" },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
